import React from 'react';
export const EmptyFolder = () => (
  <svg width="116px" height="78px" viewBox="0 0 116 78" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1508.000000, -1514.000000)">
        <path
          d="M1589,1518.846 L1589,1515"
          stroke="#F5C400"
          strokeLinecap="round"
        />
        <path
          d="M1595,1524 L1598.845,1524"
          stroke="#F5C400"
          strokeLinecap="round"
        />
        <path
          d="M1594,1520.776 L1596.847,1518"
          stroke="#F5C400"
          strokeLinecap="round"
        />
        <g
          transform="translate(1574.110932, 1542.993568) rotate(-11.000000) translate(-1574.110932, -1542.993568) translate(1546.110932, 1523.993568)"
          fillRule="nonzero"
        >
          <path
            d="M0.5,0.5 L0.5,32.9673474 C0.5,35.4526288 2.51471863,37.4673474 5,37.4673474 L44.7883108,37.4673474 L45.758899,4.4673474 L19.7039395,4.4673474 L14.9642669,0.5 L0.5,0.5 Z"
            stroke="#7350A0"
            fill="#E2E8EE"
          />
          <path
            d="M5.71385,37.5 L48.6343911,37.5 L54.6942257,18.4548055 C54.7410196,18.3077389 54.764837,18.1543316 54.764837,18 C54.764837,17.1715729 54.0932641,16.5 53.264837,16.5 L14.4008545,16.5 C13.7700949,16.5 13.2067221,16.8946016 12.9911644,17.4873854 L5.71385,37.5 Z"
            stroke="#7350A0"
            fill="#FFFFFF"
          />
          <polygon fill="#E2E8EE" points="8 35 49 35 48 37 7 37" />
          <path
            d="M4.87048026,18 L12.0999363,37.0424861 L1,21.8468028 C1.26254413,20.5720828 1.62376641,19.7061793 2.08366684,19.2490923 C2.54356728,18.7920053 3.47250508,18.3756412 4.87048026,18 Z"
            fill="#C3D3D8"
            transform="translate(6.549968, 27.521243) scale(1, -1) translate(-6.549968, -27.521243) "
          />
        </g>
        <path
          d="M1610.748,1532.874 C1610.748,1533.356 1610.357,1533.748 1609.874,1533.748 C1609.392,1533.748 1609,1533.356 1609,1532.874 C1609,1532.392 1609.392,1532 1609.874,1532 C1610.357,1532 1610.748,1532.392 1610.748,1532.874"
          fill="#5EDAB0"
        />
        <path
          d="M1537.748,1520.874 C1537.748,1521.356 1537.357,1521.748 1536.874,1521.748 C1536.392,1521.748 1536,1521.356 1536,1520.874 C1536,1520.392 1536.392,1520 1536.874,1520 C1537.357,1520 1537.748,1520.392 1537.748,1520.874"
          fill="#0B9CE5"
        />
        <g
          transform="translate(1524.000000, 1539.000000)"
          stroke="#D62793"
          strokeLinecap="round"
        >
          <path d="M3,0 L3,1.75" />
          <path d="M3,6 L3,7.75" />
          <path d="M6.75,4 L5,4" />
          <path d="M1.75,4 L0,4" />
        </g>
        <path
          d="M1622.745,1587 L1591,1587"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1545.756,1587 L1527,1587"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1517.037,1587 L1509,1587"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1588.252,1587.183 C1588.252,1589.493 1580.585,1591.365 1571.126,1591.365 C1561.667,1591.365 1554,1589.493 1554,1587.183 C1554,1584.872 1561.667,1583 1571.126,1583 C1580.585,1583 1588.252,1584.872 1588.252,1587.183"
          fill="#D0D7DA"
        />
      </g>
    </g>
  </svg>
);
